import { useState } from 'react'
import { RxTrash } from 'react-icons/rx'
import { useTypedTranslation } from '../../common/hooks/useTypedTranslation'
import { Tooltip } from '../ui/atoms/tooltip/Tooltip'
import { DeleteWorkspaceDialog } from './DeleteWorkspaceDialog'

interface DeleteWorkspaceButtonProps {
  workspaceId: string
}

/**
 * Renders a trash icon to delete a workspace (dashboard) in the workspace title bar actions,
 * and opens a dialog to confirm the deletion
 */
export function DeleteWorkspaceButton({ workspaceId }: DeleteWorkspaceButtonProps) {
  const [openDialog, setOpenDialog] = useState(false)
  const { t } = useTypedTranslation()

  return (
    <>
      <Tooltip title={t('workspace.delete_dashboard')}>
        <button
          className="flex cursor-pointer items-center justify-center rounded p-2 hover:bg-gray-1"
          onClick={() => setOpenDialog(true)}
        >
          <RxTrash size={20} />
        </button>
      </Tooltip>
      <DeleteWorkspaceDialog
        handleCloseDialog={() => setOpenDialog(false)}
        openDialog={openDialog}
        workspaceId={workspaceId}
      />
    </>
  )
}
